export enum GodziSpinType {
  none = 'none',
  freeSpin = 'FS_spin',
  freeGame = 'FG_spin',
  freeSpinToFreeGame = 'FStoFG_spin',
}
